import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  authInitialized,
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
} from "../../store/features/auth/authSlice";
import { fetchUserStart } from "../../store/features/me/userSlice";
import { buildApiUrl } from "../../api/apiClient";

const URL = buildApiUrl("/api/auth/token");

const loginApi = async (credentials) => {
  try {
    const response = await axios.post(URL, {
      username: credentials.username,
      password: credentials.password,
      grant_type: "password",
      client_id: process.env.REACT_APP_CLIENT_ID,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Credenziali non valide");
  }
};

const refreshTokenApi = async (refreshToken) => {
  try {
    const response = await axios.post(URL, {
      grant_type: "refresh_token",
      refresh_token: refreshToken,
      client_id: process.env.REACT_APP_CLIENT_ID,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Token di refresh non valido"
    );
  }
};

function* checkAuthSaga() {
  const refreshToken = localStorage.getItem("refresh_token");
  const accessToken = localStorage.getItem("access_token");

  if (refreshToken) {
    try {
      const userData = yield call(refreshTokenApi, refreshToken);
      localStorage.setItem("access_token", userData.access_token);
      yield put(loginSuccess({ ...userData, rememberMe: true }));
      yield put(fetchUserStart());
    } catch (error) {
      yield put(loginFailure("Token non valido"));
      yield put(logout());
    }

    return;
  }

  if (accessToken) {
    yield put(
      loginSuccess({
        access_token: accessToken,
        rememberMe: false,
      })
    );
    yield put(fetchUserStart());
    return;
  }

  yield put(authInitialized());
}

function* loginSaga(action) {
  try {
    const userData = yield call(loginApi, action.payload);
    localStorage.setItem("access_token", userData.access_token);
    if (action.payload.rememberMe) {
      localStorage.setItem("refresh_token", userData.refresh_token);
    } else {
      localStorage.removeItem("refresh_token");
    }
    yield put(
      loginSuccess({ ...userData, rememberMe: action.payload.rememberMe })
    );
    yield put(fetchUserStart());
  } catch (error) {
    yield put(loginFailure(error.message));
  }
}

export default function* authSaga() {
  yield takeLatest(loginStart.type, loginSaga);
  yield call(checkAuthSaga);
}
